import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from 'context/CookieConsentContext';

const CookieConsentBanner = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { status, hydrated, acceptAll, rejectNonEssential } =
    useCookieConsent();

  if (!hydrated || status !== null) return null;

  return (
    <Box
      role="dialog"
      aria-live="polite"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        padding: theme.spacing(2, 3),
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[8],
        zIndex: theme.zIndex.snackbar,
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        justifyContent="space-between"
      >
        <Typography variant="body2" sx={{ flex: 1 }}>
          {t('cookieConsent.message')}{' '}
          <Link href="/cookie-policy" underline="hover">
            {t('cookieConsent.learnMore')}
          </Link>
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={rejectNonEssential}
          >
            {t('cookieConsent.rejectNonEssential')}
          </Button>
          <Button variant="contained" color="primary" onClick={acceptAll}>
            {t('cookieConsent.acceptAll')}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CookieConsentBanner;
